module.exports = require('./helpers/bundle-url').getBundleURL('8zyGl') + "logo.c51670a8.svg";